import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";

export function CommunitySiteCountryHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '120px',
				minWidth: '120px',
				maxWidth: '120px'
			}}>
			Community site country
		</StickyHeader>
	)
}

export function CommunitySiteCountryFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CommunitySiteCountryCodeValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunitySiteCountryCodeValidated: e.value
						})
					}
				/>
				<TextFilter
					value={filter?.CommunitySiteCountryCode ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunitySiteCountryCode: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function CommunitySiteCountryContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CommunitySiteCountryCodeValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.CommunitySiteCountryCode}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}